import "./scrollArrows.css"

export function ScrollArrows({ scrollSection, scrollIndex, scrollLimit }) {
    return (
        <div className="d-flex gap-2">
            <div
                onClick={() => scrollSection(-1)}
                className={"scroll-arrow-left " + (scrollIndex === 0 ? "off" : "")}>
            </div>

            <div
                onClick={() => scrollSection(1)}
                className={"scroll-arrow-right " + (scrollIndex === scrollLimit ? "off" : "") }>
            </div>
        </div>
    )
}